import { L } from '@angular/cdk/keycodes';
import { Pipe, PipeTransform } from '@angular/core';
import { DateTime } from 'luxon';

@Pipe({
  name: 'lastUpdate'
})
export class LastUpdatePipe implements PipeTransform {

  transform(value: any): string {
    if (!value) return '';
    let lastModifiedBy = value.lastModifiedBy ?? 'unknown user';
    const lastModifiedOn = value.lastModifiedOn;

    if (lastModifiedBy === 'UNKNOWN')
       lastModifiedBy = 'unknown user';

    const dt = lastModifiedOn
      ? DateTime.fromISO(String(lastModifiedOn)).setZone('local')
      : null;

    const formattedDate = dt ? dt.toLocaleString(DateTime.DATETIME_MED) : 'unknown time';
    const user = lastModifiedBy || 'unknown user';

    return `${formattedDate} by ${user}`;
  }

}
